import { createRouter, createWebHistory } from 'vue-router'

import AppLayout from '../layouts/AppLayout.vue'
import BlankLayout from '../layouts/BlankLayout.vue'
import EarnView from '../views/EarnView.vue'
import ShipView from '../views/ShipView.vue'
import SwapsView from '../views/SwapsView.vue'
import NftView from '../views/NftView.vue'
import JourneyView from '../views/JourneyView.vue'
import RewardsView from '../views/RewardsView.vue'
import BoostsView from '@/views/BoostsView.vue'
import ProfileView from '@/views/ProfileView.vue'
import PageLayout from '@/layouts/PageLayout.vue'
import EditCharacterView from '@/views/EditCharacterView.vue'
import CollectionPage from '@/components/NftPages/CollectionPage.vue'
import NftDetailPage from '@/components/NftPages/NftDetailPage.vue'
import ErrorView from '../views/ErrorView.vue'


const routes = [
  {
    path: '',
    name: 'AppLayout',
    component: AppLayout,
    children: [
      {
        path: '',
        name: 'EarnView',
        component: EarnView,
      },
      {
        path: '/ship',
        name: 'ShipView',
        component: ShipView
      },
      {
        path: '/swaps',
        name: 'SwapsView',
        component: SwapsView
      },
      {
        path: '/nft',
        name: 'NftView',
        component: NftView,
      },
      {
        path: '/journey',
        name: 'JourneyView',
        component: JourneyView
      },
      {
        path: '/rewards',
        name: 'RewardsView',
        component: RewardsView
      },
      
    ]
  },
  {
    name: 'PageLayout',
    component: PageLayout,
    children: [
      {
        path: '/boosts',
        name: 'BoostsView',
        component: BoostsView,
      },
      {
        path: '/profile',
        name: 'ProfileView',
        component: ProfileView,
      },
      {
        path: '/editchar',
        name: 'EditCharacterView',
        component: EditCharacterView,
      },
      {
        path: '/collection',
        name: 'CollectionPage',
        component: CollectionPage
      },
      {
        path: '/nftDetail',
        name: 'NftDetailPage',
        component: NftDetailPage
      },

    ]
  },
  {
    name: 'BlankLayout',
    component: BlankLayout,
    children: [
      // {
      //   path: '/preferences',
      //   name: 'PreferencesView',
      //   component: PreferencesView
      // },
      {
        path: '/error',
        name: 'ErrorView',
        component: ErrorView
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

export default router
